import { render, staticRenderFns } from "./EditPagePolicyRule.vue?vue&type=template&id=cbb7fa2a"
import script from "./EditPagePolicyRule.vue?vue&type=script&lang=js"
export * from "./EditPagePolicyRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports